<template>
    <div>
        <div class="common-table">
            <el-table v-loading="loading" height="100%" :data="waitingRebateRecordList.beanList" row-key="id">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="俱乐部" align="center" prop="clubName"/>
                <el-table-column label="俱乐部ID" align="center" prop="clubId"/>
                <el-table-column label="返佣类型" align="center" prop="type">
                    <template slot-scope="scope">{{scope.row.type?'代充渠道':'俱乐部充值'}}</template>
                </el-table-column>
                <el-table-column label="返佣金豆数量" align="center" prop="beans"/>
                <el-table-column label="战绩流水返佣比例" align="center" prop="rebateRatio"/>
                <el-table-column label="返佣对应时间" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.date | toTime}}</template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="waitingRebateRecordList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage: 1
            }
        },
        computed: {
            ...mapState('jpbAccount', ['waitingRebateRecordList'])
        },
        methods: {
            ...mapActions('jpbAccount', ['getWaitingRebateRecordList']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getWaitingRebateRecordList(page).then(() => {
                    this.loading = false;
                })
            }
        }
    }
</script>